import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import {
  getIsLoggedInSelector,
  getHasAuthLoadedSelector,
} from '@americanexpress/travel-selectors';
import { useDDL } from '@americanexpress/react-ddl';
import browserCookies from 'browser-cookies';

const DigitalDataLayer = () => {
  const { updateDDL } = useDDL();
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const hasAuthLoaded = useSelector(getHasAuthLoadedSelector);

  React.useEffect(() => {
    if (hasAuthLoaded) {
      updateDDL({ name: 'user.authenticated', value: !!isLoggedIn });
    }
  }, [hasAuthLoaded, isLoggedIn]);

  React.useEffect(() => {
    updateDDL({ name: 'user.publicGuid', value: browserCookies.get('blueboxpublic') });
  }, []);

  return null;
};

export default memo(DigitalDataLayer);
